import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FeatureRow } from '../../../../widgets/feature-row/feature-row';

@Component({
  selector: 'app-ticket-management',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [RouterModule, FeatureHero, FeatureRow],
})
export class TicketManagement {
  whatIsParagraphs = ["Ticket management software is used by businesses to track and manage customer service requests and inquiries. Customer service teams use it to process incoming tickets, assign them to the appropriate team members, and provide efficient customer service. The software includes ticket tracking, categorization, assignment and routing, and automated notifications. The software also helps agents to prioritize tickets, track and analyze ticket data, and report on customer service performance."];

  automatedTicketingParagraphs = ["Automated ticketing management is a system designed to streamline the process of creating, managing, and resolving customer support tickets. The system allows customers to submit tickets through a customer service portal, which can be accessed by the support team to investigate and resolve the issue. Automated ticketing management solutions often include features such as ticket tagging, automatic ticket routing, ticket status tracking, and customer notifications. This helps to ensure that customer issues are addressed quickly and efficiently."];

  howItWorksParagraphs = [
    "Infraon Ticketing Software is a cloud-based help desk ticketing system designed to help businesses organize and manage customer support inquiries. It enables users to create, assign, and track tickets and communicate with customers and other stakeholders.",
    "The software offers features such as customizable ticket forms, automatic ticket routing, and reporting tools. Additionally, users can integrate Infraon Ticketing Software with other applications such as CRM, email, and social media platforms. The software also provides a self-service portal to enable customers to submit tickets, access support resources, and keep track of their requests."
  ];

  keyFeaturesItems = [
    'KPI Dashboard',
    'Bulk Excel Import/ Export',
    'Custom Reports',
    'Custom Roles',
    'Report Export',
    'Custom Alerts',
    'Scheduled Reports',
    'Customizable Fields'
  ];

  constructor() {}

}